import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, errMsg } from "@/components/email/EmParts";
import RuleGroup from "@/components/email/RuleGroup";
import AudiencePreview from "@/components/email/AudiencePreview";

export default function EmSegmentBuilder() {
  const { id } = useParams();
  const nav = useNavigate();
  const { can } = useAuth();
  const manage = can("email_marketing.manage");
  const [fields, setFields] = useState(null);
  const [seg, setSeg] = useState({ name: "", description: "", rules: { op: "and", rules: [] } });
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get("/email-marketing/segment-fields").then((r) => setFields(r.data));
    if (id) api.get(`/email-marketing/segments/${id}`).then((r) => setSeg(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [id]);
  useEffect(() => {
    setP(null);
    const t = setTimeout(() => api.post("/email-marketing/segments/preview", { rules: seg.rules }).then((r) => setP(r.data)).catch((e) => { setP({ matched: 0, eligible: 0, recipients: 0, excluded: {} }); toast.error(errMsg(e)); }), 500);
    return () => clearTimeout(t);
  }, [seg.rules]);
  const save = async () => {
    try {
      const body = { name: seg.name, description: seg.description, rules: seg.rules };
      if (id) await api.put(`/email-marketing/segments/${id}`, body); else await api.post("/email-marketing/segments", body);
      toast.success("Segment saved"); nav("/email-marketing/lists");
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!fields) return null;
  return (
    <div className="grid lg:grid-cols-3 gap-4" data-testid="em-segment-builder">
      <div className="lg:col-span-2 space-y-3">
        <div className="grid sm:grid-cols-2 gap-2">
          <Input value={seg.name} onChange={(e) => setSeg({ ...seg, name: e.target.value })} placeholder="Segment name" data-testid="seg-name" />
          <Input value={seg.description} onChange={(e) => setSeg({ ...seg, description: e.target.value })} placeholder="Description (optional)" data-testid="seg-description" />
        </div>
        <RuleGroup node={seg.rules} fields={fields} onChange={(rules) => setSeg({ ...seg, rules })} />
        <p className="text-[11px] text-slate-400">Segments are dynamic: they are recalculated from live customer, purchase, ownership and engagement data every time they are used.</p>
      </div>
      <div className="space-y-3">
        <Card title="Live audience preview" testId="seg-preview-card"><AudiencePreview p={p} testId="seg-preview" /></Card>
        {manage && <Button className="w-full" onClick={save} disabled={!seg.name.trim()} data-testid="seg-save">Save segment</Button>}
      </div>
    </div>
  );
}
